export * from '@meettry/ui-components/components/organisms/ContactForm/ContactForm';
import GoogleForm from '@meettry/ui-components/components/organisms/ContactForm/googleForm';
export default GoogleForm;
